import { render, staticRenderFns } from "./eje.vue?vue&type=template&id=376f66b2&scoped=true&"
import script from "./eje.vue?vue&type=script&lang=ts&"
export * from "./eje.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376f66b2",
  null
  
)

export default component.exports